import { Route, Routes } from "react-router-dom";
import AppLayout from "./layouts/AppLayout";
import IndexPage from "./pages";
import { CaseStudies } from "./components/index/our.cases.data";
import { Case } from "./components/case/case";
import FirstArticlePage from "./pages/blog/first_article";
import SecondArticlePage from "./pages/blog/second_article";
import ImprintPage from "./pages/imprint";
import ThirdArticlePage from "./pages/blog/third_article";
import Blog from "./pages/blog/blog";

import React from "react";

function AppRoutes() {
    return (
        <Routes>
            <Route path='/' element={<AppLayout />}>
                <Route index element={<IndexPage />} />
                {CaseStudies.map((caseStudy, index) => (
                    <Route
                        key={caseStudy.path}
                        path={caseStudy.path}
                        element={
                            <Case
                                headerText={caseStudy.descriptionTextIDs}
                                logo={caseStudy.logo}
                                solutions={caseStudy.solutionsIDs}
                            />
                        }
                    />
                ))}
                <Route path='net-zero' element={<FirstArticlePage />} />
                <Route path='decarbonization' element={<SecondArticlePage />} />
                <Route path='imprint' element={<ImprintPage />} />
                <Route path='oftd-finance' element={<ThirdArticlePage />} />
                <Route path='blog' element={<Blog />} />
                <Route path='*' element={<IndexPage />} />
            </Route>
        </Routes>
    );
}

export default AppRoutes;
